// Update SITE_URL once you know the final live domain — every page's
// canonical & Open Graph URLs are built from this single constant.
export const SITE_URL = "https://www.ssarchitectsinteriors.com";
export const SITE_NAME = "SS Architects & Interiors";
export const DEFAULT_OG_IMAGE = "/home1/assets/img/logo.png";
